import { defineNuxtPlugin } from '#imports'
import { Wallet } from '@injectivelabs/wallet-base'
import { localStorage } from '@/app/Services'
import type {
  StateTree,
  PiniaPluginContext,
  SubscriptionCallback,
  SubscriptionCallbackMutationPatchObject
} from 'pinia'

const stateToPersist = {
  wallet: {
    wallet: Wallet.Metamask,
    session: '',
    address: '',
    addresses: '',
    injectiveAddress: '',
    addressConfirmation: ''
  },

  sharedWallet: {
    walletConnectStatus: '',
    wallet: Wallet.Metamask,
    address: '',
    addresses: '',
    injectiveAddress: '',
    addressConfirmation: '',
    session: '',

    authZ: {
      address: '',
      direction: '',
      injectiveAddress: '',
      defaultSubaccountId: ''
    },
    autoSign: {
      privateKey: '',
      expiration: '',
      injectiveAddress: '',
      duration: ''
    }
  }
} as Record<string, Record<string, any>>

const persistState = (
  mutation: SubscriptionCallbackMutationPatchObject<StateTree>,
  state: StateTree
) => {
  const storeState = stateToPersist[mutation.storeId]

  if (!storeState) {
    return
  }

  const keysToPersist = Object.keys(storeState)

  if (!mutation.payload) {
    return
  }

  const shouldPersistState =
    keysToPersist.length > 0 &&
    Object.keys(mutation.payload || []).some((key) => {
      return keysToPersist.includes(key)
    })

  if (!shouldPersistState) {
    return
  }

  const updatedState = keysToPersist.reduce((stateObj, key) => {
    return {
      ...stateObj,
      [key]: mutation.payload[key] || state[key]
    }
  }, {})

  const existingState = (localStorage.get('state') || {}) as any

  localStorage.set('state', {
    ...stateToPersist,
    ...existingState,
    [mutation.storeId]: {
      ...updatedState
    }
  })
}

function piniaStoreSubscriber({ store }: PiniaPluginContext) {
  const localState = localStorage.get('state') as any

  if (localState[store.$id]) {
    store.$state = { ...store.$state, ...localState[store.$id] }
  }

  store.$subscribe(persistState as SubscriptionCallback<StateTree>)
}

export default defineNuxtPlugin(
  ({
    vueApp: {
      config: { globalProperties }
    }
  }) => {
    globalProperties.$pinia.use(piniaStoreSubscriber)
  }
)
